import * as React from 'react'
const FilterIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path d="M26.29 12.25H5.71a.63.63 0 00-.55.7.64.64 0 00.55.55h20.58a.63.63 0 00.55-.7.64.64 0 00-.55-.55zm-2.17 6.25H7.87a.63.63 0 00-.55.7.64.64 0 00.55.55h16.25a.63.63 0 00.55-.7.64.64 0 00-.55-.55zM10 24.75h12a.63.63 0 01.55.7.64.64 0 01-.55.55H10a.63.63 0 01-.55-.7.64.64 0 01.55-.55z" className="-primary-color" fill="#a5aab8" fillRule="evenodd"/>
      <path d="M28.46 6H3.54a.58.58 0 00-.54.62.6.6 0 00.54.63h24.92a.6.6 0 00.54-.63.58.58 0 00-.54-.62z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default FilterIcon